import Button from '@admin/components/button'
import Token from '@admin/components/token'
import List from '@admin/components/list'
import PropTypes from 'prop-types'
import Answer from './answer'
import React from 'react'

class AnswersField extends React.PureComponent {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    defaultValue: PropTypes.array,
    required: PropTypes.bool,
    onChange: PropTypes.func,
    onReady: PropTypes.func,
    onValid: PropTypes.func
  }

  static defaultProps = {
    onChange: () => {},
    onReady: () => {}
  }

  state = {
    answers: []
  }

  _handleAdd = this._handleAdd.bind(this)
  _handleCreate = this._handleCreate.bind(this)
  _handleEdit = this._handleEdit.bind(this)
  _handleValidate = this._handleValidate.bind(this)

  render() {
    return (
      <>
        <List { ...this._getList() } />
        <Button { ...this._getAdd() } />
      </>
    )
  }

  componentDidMount() {
    const { defaultValue } = this.props
    if(defaultValue) this.setState({
      answers: defaultValue
    })
    this.props.onReady(this._handleValidate)
  }

  componentDidUpdate(prevProps, prevState) {
    const { answers } = this.state
    if(!_.isEqual(answers, prevState.answers)) {
      this.props.onChange(answers)
    }
  }

  _getAdd() {
    return {
      label: '+ t(add answer)',
      className: 'link',
      handler: this._handleAdd
    }
  }

  _getDescription(answer) {
    const { operation, text } = answer
    if(operation === '$eq') return `equals "${text}"`
    if(operation === '$lk') return `contains "${text}"`
  }

  _getList() {
    const { answers } = this.state
    return {
      actions: (item, index) => [
        {
          svg: 'x',
          confirm: 't(Are you sure you want to remove this answer?)',
          handler: this._handleRemove.bind(this, index)
        }
      ],
      items: answers,
      empty: <Token text='t(You have not yet added any answers)' />,
      format: (answer) => <Token text={ this._getDescription(answer) } />,
      onEdit: this._handleEdit,
      onRemove: {
      }
    }
  }

  _getNew() {
    return {
      mode: 'new',
      onDone: this._handleCreate
    }
  }

  _getEdit(index) {
    const answer = this.state.answers[index]
    return {
      answer,
      mode: 'edit',
      onDone: this._handleUpdate.bind(this, index)
    }
  }

  _handleAdd() {
    this.context.form.push(Answer, this._getNew())
  }

  _handleCreate(answer) {
    const { answers } = this.state
    this.setState({
      answers: [
        ...answers,
        answer
      ]
    })
  }

  _handleEdit(answer, index) {
    this.context.form.push(Answer, this._getEdit(index))
  }

  _handleRemove(index) {
    const { answers } = this.state
    this.setState({
      answers: answers.filter((answer, i) => {
        return i !== index
      })
    })
  }

  _handleUpdate(i, updated) {
    const { answers } = this.state
    this.setState({
      answers: answers.map((answer, index) => {
        return index === i ? updated : answer
      })
    })
  }

  _handleValidate() {
    const { answers } = this.state
    const { required, onValid } = this.props
    if(required && (!answers || answers.length === 0)) {
      return onValid(null, ['You must add at least 1 answer'])
    }
    onValid(answers)
  }

}

export default AnswersField
